import { render, staticRenderFns } from "./BowSticky.vue?vue&type=template&id=4ff30830&"
import script from "./BowSticky.vue?vue&type=script&lang=js&"
export * from "./BowSticky.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports